import type { FunctionComponent } from "react";
import Profile from "components/shared/Profile";

export interface ContactProps {
  name?: string;
  phone?: string;
  email?: string;
}

const Contact: FunctionComponent<ContactProps> = function ({
  name = "",
  phone = "",
  email = "",
}) {
  return (
    <Profile.Section title="Contact details">
      <Profile.Property label="Contact name" value={name} />
      <Profile.Property label="Contact phone" value={phone} />
      <Profile.Property label="Contact email" value={email} />
    </Profile.Section>
  );
};

export default Contact;
